import z from 'zod';
import {firestoreTimestampSchema} from '../_other/firestore/firestoreTimestampSchema';
import {questionStatusSchema} from './QuestionStatus';

export const questionReviewDbSchema = z.object({
  uid: z.string(),
  name: z.string().default('Unknown'),
  result: questionStatusSchema,
  timestamp: firestoreTimestampSchema,
  note: z.string().optional(),
});

export type QuestionReviewDb = z.infer<typeof questionReviewDbSchema>;
